import { render, staticRenderFns } from "./ProjectStrip.vue?vue&type=template&id=c7b46e8a&scoped=true"
import script from "./ProjectStrip.vue?vue&type=script&lang=js"
export * from "./ProjectStrip.vue?vue&type=script&lang=js"
import style0 from "./ProjectStrip.vue?vue&type=style&index=0&id=c7b46e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b46e8a",
  null
  
)

export default component.exports